import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@systemeio/components';
import React from 'react';
interface EventsSkeletonInterface {
  revenueLength: number;
}
const EventSkeletonItem = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="size-8 shrink-0 rounded-md" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex h-6 items-center justify-between gap-3"><Skeleton className="h-4 w-[120px]" /><Skeleton className="h-3.5 w-[70px]" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex gap-3">{t0}<div className="flex w-full flex-col">{t1}<div className="flex h-6 items-center"><Skeleton className="h-4 w-full" /></div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
const EventsSkeleton = t0 => {
  const $ = _c(5);
  const {
    revenueLength
  } = t0;
  const itemsCount = revenueLength > 3 ? 12 : 8;
  let t1;
  if ($[0] !== itemsCount) {
    t1 = Array.from(Array(itemsCount).keys());
    $[0] = itemsCount;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== itemsCount || $[3] !== t1) {
    t2 = <div className="flex flex-col gap-3 overflow-hidden"><ul className="flex flex-col gap-4">{t1.map((el, idx) => <React.Fragment key={idx}><li><EventSkeletonItem /></li>{!(idx === itemsCount - 1) && <hr className="border-border-100" />}</React.Fragment>)}</ul></div>;
    $[2] = itemsCount;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default EventsSkeleton;